import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { LoadStatus } from '../../../store/state/shipment-load/models';
import { TransportOrderLoad } from '../../../store/state/shipment-transport-order/models';
import { Origin } from '../../../store/state/monitoring/transport/constants';
import { DeviationType } from '../../../store/models';
import { IconNames } from '../../../common/constants';
import { IntrackFeatureModule } from '../../../intrack-feature.module';
import { StatusCodeComponent } from '../../status-code/status-code.component';
import { TransportModeComponent } from '../../transport-mode/transport-mode.component';
import { SvgIconComponent } from '../../svg-icon/svg-icon.component';

@Component({
  selector: 'ui-load-info-bar-header-default',
  imports: [
    CommonModule,
    RouterModule,
    TranslateModule,
    IntrackFeatureModule,
    StatusCodeComponent,
    TransportModeComponent,
    SvgIconComponent,
  ],
  templateUrl: './load-info-bar-header-default.component.html',
  styleUrls: ['./load-info-bar-header-default.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoadInfoBarHeaderDefaultComponent {
  @Input() load: TransportOrderLoad;
  @Input() loadStatus: LoadStatus;
  @Input() hasLabel: boolean;
  @Input() hasSpeedUpInfo: boolean;
  @Input() hasRegion: boolean;

  deviationType = DeviationType;
  origin = Origin;
  iconNameList = IconNames;
}
